__turbopack_context__.v({
  "benefitContainer": "benefits-module-scss-module__oYEW7a__benefitContainer",
  "benefitDescription": "benefits-module-scss-module__oYEW7a__benefitDescription",
  "benefitSlide": "benefits-module-scss-module__oYEW7a__benefitSlide",
  "benefitSliderWrapper": "benefits-module-scss-module__oYEW7a__benefitSliderWrapper",
  "benefitTitle": "benefits-module-scss-module__oYEW7a__benefitTitle",
  "benefitsContainer": "benefits-module-scss-module__oYEW7a__benefitsContainer",
  "benefitsPattern": "benefits-module-scss-module__oYEW7a__benefitsPattern",
});
